"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _react = _interopRequireDefault(require("react"));
var _HiInput = _interopRequireDefault(require("./HiInput"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * Construit une barre de recherche avec icône Search (Magnify),
 * permet de filtrer une liste d'éléments en spécifiant le nom de la/les propriétés sur lesquelles filtrer,
 * retour la liste d'élément filtré.
 * Un bouton reset s'affiche à la saisie permettant de réinitialiser l'input.
 */
var HiSearchField = /*#__PURE__*/function (_React$Component) {
  function HiSearchField(props) {
    var _this;
    (0, _classCallCheck2.default)(this, HiSearchField);
    _this = _callSuper(this, HiSearchField, [props]);
    _this.state = {
      inputValue: ''
    };
    _this.filterOnProperties = _this.filterOnProperties.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleReset = _this.handleReset.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(HiSearchField, _React$Component);
  return (0, _createClass2.default)(HiSearchField, [{
    key: "filterOnProperties",
    value: function filterOnProperties(item, search) {
      if (!this.props.filterPropertyList || this.props.filterPropertyList.length < 1) {
        // If no properties specify, search on item
        return item.toString().toLowerCase().search(search.toLowerCase()) !== -1;
      }
      var searchSucceed = false;
      this.props.filterPropertyList.forEach(function (filter) {
        var itemProperty = null;
        if (filter.indexOf('.') > 0) {
          itemProperty = item[filter.split('.')[0]][filter.split('.')[1]];
        } else {
          itemProperty = item[filter];
        }
        if (itemProperty.toString().toLowerCase().search(search.toLowerCase()) !== -1) {
          searchSucceed = true;
        }
      });
      return searchSucceed;
    }
  }, {
    key: "handleChange",
    value: function handleChange(event, inputValue) {
      var _this2 = this;
      var searchedValue;
      if (typeof inputValue !== 'undefined' && typeof event.target.value === 'undefined') {
        searchedValue = inputValue;
      } else {
        searchedValue = event.target.value;
      }
      this.setState({
        inputValue: searchedValue
      });
      if (this.props.onSearch === undefined) {
        var currentParent = null;
        var filteredList = [];
        this.props.itemList.forEach(function (item) {
          var add = _this2.filterOnProperties(item, searchedValue);
          if (item.hasChildren === true && add === false) {
            currentParent = item;
          }
          if (add === true) {
            if (currentParent !== null && item.parentId === currentParent.id) {
              filteredList.push(currentParent);
              currentParent = null;
            }
            filteredList.push(item);
          }
        });
        this.props.onFilteredList(filteredList);
      } else {
        this.props.onSearch(event, searchedValue);
      }
    }
  }, {
    key: "handleReset",
    value: function handleReset() {
      this.setState({
        inputValue: ''
      });
      if (typeof this.props.onSearch === 'undefined') {
        this.props.onFilteredList(this.props.itemList);
      } else {
        this.props.onSearch(undefined, '');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        placeholder = _this$props.placeholder,
        others = (0, _objectWithoutProperties2.default)(_this$props, ["placeholder"]);
      return /*#__PURE__*/_react.default.createElement(_HiInput.default, (0, _extends2.default)({
        placeholder: placeholder,
        onReset: this.handleReset,
        onChange: this.handleChange,
        value: this.state.inputValue,
        startAdornment: 'search'
      }, others));
    }
  }]);
}(_react.default.Component);
HiSearchField.defaultProps = {
  placeholder: 'Search'
};
var _default = exports.default = HiSearchField;